import React, { useState } from 'react'
import { toast } from 'react-toastify'
import Box from '@mui/material/Box'
import { useQuery } from '@tanstack/react-query'
import PropTypes from 'prop-types'

import OrderAPI from '../../../../../../api/orbitV1/OrderAPI'

import OrderStates from './OrderStates'
import OrderStateTabView from './OrderStateTabView'
import RecommendedActions from './RecommendedActions'
/**
 * @param {Object} props
 * @param {import('../../../../../../types/order.type').OrderModel} props.order
 * @param {import('../../../../../../types/provision.type').ProvisioningStatus} props.provisionedItems
 */
function OrderStateView(props) {
  const [propOrder, setPropOrder] = useState(props.order)

  const { data, error } = useQuery(
    'orderConfirmation',
    async () => {
      return OrderAPI.getOrderStatus(propOrder.orderNo)
    },
    { refetchInterval: 10000 }
  )

  if (
    !error &&
    data &&
    data.status !== propOrder.status &&
    data.status === 'DELIVERED'
  ) {
    setPropOrder(data)
    toast.success(
      'The delivery has been completed by your Grab Delivery driver.'
    )
  }

  return (
    <>
      <Box sx={{ marginY: '15px' }}>
        <OrderStates order={propOrder} />
      </Box>
      <Box sx={{ marginY: '15px' }}>
        <RecommendedActions order={propOrder} />
      </Box>
      <Box>
        <OrderStateTabView
          order={propOrder}
          provisionedItems={props.provisionedItems}
        />
      </Box>
    </>
  )
}

OrderStateView.propTypes = {
  order: PropTypes.object,
  provisionedItems: PropTypes.array
}

export default OrderStateView
